module.exports = __webpack_public_path__ + "img/05_BC6_become_spend_quality_time.29266ee0.jpg";